export const getDSAPeakBuffer = state => state.dsa && state.dsa.dsa && state.dsa.dsa.peak_buffer;




// WEBPACK FOOTER //
// ./src/selectors/dsaSelectors.js